import { CombinedTimeSeriesOverview } from 'components/TimeSeriesOverview';
import { GOOGLE_METADATA_BY_KEY } from 'utils/metrics';
import GoogleTimeSeries from 'components/DataVis/Charts/GoogleTimeSeries/GoogleTimeSeries';
import { timeseries as tsCopy } from '@/copy';
import { useEntityPageContext } from './EntityContext';

/** The searches series, in the shape the chart takes. */
export const googleSeries = ({ page }) =>
    page.series && page.series.length
        ? [
              {
                  id: `${page.entityType === 'brands' ? 'brand' : 'category'}-${page.entityId}`,
                  name: page.timeSeriesName,
                  timeSeries: page.series,
                  color: page.theme.gray_1,
                  predictionColor: page.theme.purple_1,
              },
          ]
        : null;

const growth = (M) => [M.YoY, M.QoQ, M.MoM];

/** Google's searches chart, with its metric overview underneath. */
const GoogleEntityChart = ({ data, skipPrediction, isLoading, ...rest }) => {
    const page = useEntityPageContext();
    const { name, country, entityId, entityType, row } = page;
    const loading = isLoading === undefined ? page.isLoading : isLoading;

    return (
        <GoogleTimeSeries
            data={data}
            showPlaceholder={!data}
            placeholderMessage={loading ? tsCopy.loading : tsCopy.empty}
            isLoading={loading}
            chartHeight={250}
            name={name}
            skipPrediction={skipPrediction}
            country={country ? country.id : null}
            {...(entityType === 'brands'
                ? { brand: entityId }
                : { category: entityId })}
            dataSource="google"
            {...rest}
        >
            <CombinedTimeSeriesOverview
                isLoading={loading}
                metrics={
                    row
                        ? [
                              {
                                  metrics: row || {},
                                  metricsList: growth(GOOGLE_METADATA_BY_KEY),
                                  defaultMetric: growth(
                                      GOOGLE_METADATA_BY_KEY,
                                  )[0],
                              },
                          ]
                        : null
                }
                predictionMetrics={
                    row && !skipPrediction
                        ? [
                              {
                                  metrics: row || {},
                                  metricsList: [
                                      GOOGLE_METADATA_BY_KEY.predictedYoY,
                                  ],
                                  defaultMetric:
                                      GOOGLE_METADATA_BY_KEY.predictedYoY,
                              },
                          ]
                        : null
                }
                showDataSource={false}
            />
        </GoogleTimeSeries>
    );
};

export default GoogleEntityChart;
